module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0001.jpg?v=183e45d4";